import React from 'react';
import { Box, HStack, VStack, Container, Heading, Text } from '@chakra-ui/react';

import SynchronizationSchedule from './components/SynchronizationSchedule';
import SynchronizeStores from './components/SynchronizeStores';
import SyncProgressSection from './components/SyncProgressSection';
import { useColors } from './components/colors';

const StoreSync = () => {
  const { textColor, subTextColor } = useColors();

  return (
    <Container maxW="container.2xl" py={8} mt="50px">
      <VStack spacing={8} align="stretch">
        <Box mb={6}>
          <Heading size="xl" color={textColor} mb={2}>
            Store Synchronization
          </Heading>
          <Text fontSize="lg" color={subTextColor}>
            Manage your store synchronization settings and perform manual syncs.
          </Text>
        </Box>
        <HStack spacing={8} align="stretch">
          <SynchronizationSchedule />
          <SynchronizeStores />
        </HStack>
        <SyncProgressSection />
      </VStack>
    </Container>
  );
};

export default StoreSync;
